import { Point } from "pytha";
import { ModelUtils, PointT } from "pytha";

/**
 * 漫游点
 */
export class RoamPointT extends PointT {
    type = "RoamPointT";
    baseType = "PointT";
    group: { [key: number]: string[] } = {};
    // TODO 关键点/绑定点 等 后续业务添加

    // 是否是关键点，可游览停留的点
    private isKeyPoint: boolean = false;
    // 关键点标签
    private keyLabel: string = "";

    readonly positionUpdateCallBack: boolean = true;

    constructor(position = new Point(), uuid = null) {
        super(position, uuid);
        this.uuid = ModelUtils.generateUUID();
        this.keyLabel = `漫游点-${ModelUtils.generateUUID().substring(0, 6)}`
    }

    setIsKeyPoint(isKeyPoint: boolean) {
        this.isKeyPoint = isKeyPoint;
    }

    getIsKeyPoint() {
        return this.isKeyPoint;
    }

    setKeyLabel(keyLabel: string) {
        this.keyLabel = keyLabel;
    }

    getKeyLabel() {
        return this.keyLabel;
    }

    copy(point: PointT): this;
    copy(roamPoint: RoamPointT): this;
    copy(point: any): this {
        super.copy(point); // 调用父类的 copy 方法
        if (point instanceof RoamPointT) {
            this.group = point?.group;
        }
        return this;
    }

    clone(rename: boolean = false): this {
        const component = new RoamPointT().copy(this) as this; // 创建新实例并复制属性
        component.uuid = ModelUtils.generateUUID(); // 生成新的 UUID
        if (rename) {
            component.name = `${component.name}-${ModelUtils.generateUUID().substring(0, 6)}`;
        }
        component.isKeyPoint = this.isKeyPoint;
        component.keyLabel = this.keyLabel;
        return component;
    }

    toJson(rename: boolean = false) {
        const json = super.toJson();
        return {
            ...json,
            isKeyPoint: this.isKeyPoint,
            keyLabel: this.keyLabel,
        };
    }

    fromJson(json) {
        super.fromJson(json);
        this.isKeyPoint = json?.isKeyPoint;
        this.keyLabel = json?.keyLabel;
        return this;
    }
}